<template>
  <div id="CpapMaskSelectModal" style="width: 1350px;height:1100px;margin-left:350px;margin-top:20px;">
    <div class="modal-card" style="width: 100%;height:100%;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">マスク選択</p>
      </header>
      <section class="modal-card-body">
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable" style="width:1300px;">
            <tr style="height:200px;">
              <th style="width:200px;position: relative;">
                マスク種類
                <div style="position: absolute;bottom: 10px;left: 50%;transform: translateX(-50%);width:100%;"><input type="checkbox" style="width:20px;" v-model="maskSwitch"/>マスク一覧を表示する</div>
              </th>
              <td style="width:200px;">
                <select id="maskType" v-model="maskType" @change="setMaskType">
                  <option value=""></option>
                  <option v-for="item in maskTypeList" :key="item" :value="item">{{item}}</option>
                </select>
              </td>
              <td style="width:200px;">
                <div style="width:200px;height:200px;">
                  <template v-if="maskType && maskList[maskType].fileName">
                    <img style="width:200px;height:200px;" :src="require('@/assets/maskPng/'+maskList[maskType].fileName+'.png')">
                  </template>
                </div>
              </td>
              <td style="color:red;font-size:15px;width:700px;">
                <span v-if="isMagnet">※マグネティックヘッドギアクリップを用いて装着<br>マグネットの影響を受ける可能性がある機器が体に埋め込まれている患者およびそのような家族、介護者、ベッドパートナーが近くにいるような場合でのマスクの使用は禁じられています。<br>詳細は添付文書又は取扱説明書をご参照ください。</span>
              </td>
            </tr>
            <tr style="height:250px;" v-if="maskSwitch">
              <td colspan="4" >
                <img style="height:250px;" :src="require('@/assets/maskPng/maskList.png')">
              </td>
            </tr>
          </table>
        </div>
        <!-- 検索結果 -->
        <div class="result-area" v-if="maskType">
          <span class="annotation">★印は推奨セット</span>
          <b-table
            v-if="maskType"
            id="cpapMaskSelectTable"
            :data="displayData"
            paginated
            :per-page="pageSize"
            pagination-position="both"
            default-sort="id"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="id" label="" width="5" centered>
                <b-radio class="customRadio" name="radioItem" v-model="selectedItem" :native-value="props.row"></b-radio>
              </b-table-column>
              <b-table-column field="frequentlyUsed" label="マスク種類" width="100" centered sortable>
                <span v-if="props.row.frequentlyUsed">★</span>{{props.row.maskType }}<br>
              </b-table-column>
              <b-table-column field="cushionSize" label="クッションサイズ" width="60" centered sortable>{{props.row.cushionSize }}</b-table-column>
              <b-table-column field="frameSize" label="フレームサイズ" width="60" centered sortable>{{props.row.frameSize}}</b-table-column>
              <b-table-column field="fixingMethod" label="固定方法" width="100" centered sortable>{{props.row.fixingMethod}}</b-table-column>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="save" :disabled="!selectedItem">決定</button>
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "CpapMaskSelectModal",
  props: {
    formatType:null
  },
  methods: {
    save: function() {
      this.$emit('select', this.selectedItem);
      this.$parent.close();
    },
    doSearch: function() {
      let _this = this;
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.internalCpap.getCpapMaskListPOST({
            body:{
              formatType: _this.formatType
            }
          });
        },
        function(result) {
          // 検索結果取得
          _this.data = result.obj
          _this.displayData = _this.data
          _this.maskTypeList = _this.data.map(item => item.maskType)
          _this.maskTypeList = Array.from(new Set(_this.maskTypeList))
          _this.maskTypeList.sort(function (a, b) {
            return _this.maskList[a].sortNum - _this.maskList[b].sortNum
          });
        },
        function(result) {
          // エラーメッセージ表示
          _this.showErrorMessage(result);
        }
      );
    },
    setMaskType: function() {
      this.selectedItem = '';
      if(this.maskType){
        this.displayData = this.data.filter(val => val.maskType==this.maskType)
        this.displayData.sort(function (a, b) {
          return a.displayOrder - b.displayOrder;
        });
        this.isMagnet = this.displayData[0].magnet
      }else{
        this.isMagnet = false
      }
    }
  },
  data() {
    var maskList = {
      "ﾋﾟｺﾈｰｻﾞﾙﾏｽｸ":{sortNum:1, fileName:"picoNesalMask"},
      "ｳｨｽﾌﾟﾈｰｻﾞﾙﾏｽｸ":{sortNum:2, fileName:"wispNesalMask"},
      "ﾄﾞﾘｰﾑｳｪｱﾈｰｻﾞﾙﾏｽｸ":{sortNum:3, fileName:"dreamWearNasalMask"},
      "ﾄﾞﾘｰﾑｳｨｽﾌﾟﾈｰｻﾞﾙﾏｽｸ":{sortNum:4, fileName:"dreamWispNasalMask"},
      "ｺﾝﾌｫｰﾄｼﾞｪﾙﾌﾞﾙｰ":{sortNum:5, fileName:"comfortGelBlue"},
      "ﾄﾞﾘｰﾑｳｪｱ ｼﾘｺﾝﾋﾟﾛｰﾏｽｸ":{sortNum:6, fileName:"dreamWearSiliconePillowMask"},
      "ﾄﾞﾘｰﾑｳｪｱﾌﾙ":{sortNum:7, fileName:"dreamWearFull"},
      "ｱﾏﾗﾋﾞｭｰﾌﾙﾌｪｲｽﾏｽｸ":{sortNum:8, fileName:"amaraViewFullFaceMask"},
      "ｱﾏﾗﾌﾙﾌｪｲｽﾏｽｸ":{sortNum:9, fileName:"amaraFullFaceMask"},
      "ｱﾏﾗｼﾞｪﾙﾌﾙﾌｪｲｽﾏｽｸ":{sortNum:10, fileName:"amaraGelFullFaceMask"},
      "ｳｨｽﾌﾟ小児用ﾈｰｻﾞﾙﾏｽｸ":{sortNum:11, fileName:"wispPediatricNasalMask"},
      "ﾌｨｯﾄﾗｲﾌ":{sortNum:12, fileName:"fitLife"},
      "その他":{sortNum:13, fileName:null},
    }
    return {
      maskType:"",
      selectedItem:'',
      maskTypeList:[],
      data:[],
      displayData:[],
      maskList,
      isMagnet:false,
      maskSwitch:true,
      pageSize:5
    };
  },
  filters: {},
  components: {},
  mounted: function () {
    this.doSearch()
  },
  watch: {
    maskSwitch(value) {
      if(!value){
        this.pageSize = 10
      }else{
        this.pageSize = 5
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.customRadio {
  width:10px;
}
.annotation {
  float:left;
  margin-top:20px;
  margin-left:10px;
  font-size: 1.0em;
}
.modal-card-body {
  padding-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/CpapMaskSelectModal.vue